export const INITIAL_STATE = {
    batchError: false,
    errorType: null,
    errorMessage: null,
    errorContent: null,
    errorNumber: null,
    pageName: null,
};
